import Page404 from "../src/pages/ServicePage/Page404";

export default Page404;
